import AdditionalTasksViewModalComponent from './view-modal.component'

const AdditionalTasksViewModalModule = angular.module('cdbl.view-modal', [

])
  .component('cdblAdditionalTasksViewModal', AdditionalTasksViewModalComponent)
  .name

export default AdditionalTasksViewModalModule
